<template>
  <div class="mb-3 d-flex flex-wrap">
    <div v-for="(attribute, ai) in itemAttributes" :key="attribute.image + ai">
      <WCImage
        imageClass="attribute"
        :imageSrc="`${$configuration.cdn}/api/img/${attribute.image}?h=30&w=30`"
        :imageTitle="attribute.name"
        :imageAlt="healthAttributeImgAltText(attribute.name)"
        :useCustomDefaultImage="false"
        defaultClass="font-size-2xl"
      />
      <span class="mx-2">{{ attribute.name }}</span>
    </div>
  </div>
</template>

<script>
import WCImage from '@/components/WCImage/WCImage.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {
    WCImage,
  },
  props: {
    itemAttributes: {
      type: Array,
    },
  },
  methods: {
    healthAttributeImgAltText(attributeName) {
      return this.$t('healthAttributeImgAltText', { attributeName });
    },
  },
});
</script>
